<template>
  <div>
    <banner-pc></banner-pc>
    <banner-m></banner-m>
  </div>
</template>

<script>
import bannerPc from './banner-pc'
import bannerM from '../banner-m'

export default {
  components: {
    bannerPc,
    bannerM
  }
}
</script>
